const DEFAULT_TITLE = "Admin";

const DEFAULT_FAVICON = "/favicon.png";

//  Apply branding to browser
export const applyBranding = ({ title, favicon } = {}) => {
  // Browser title
  document.title = title || DEFAULT_TITLE;

  // Browser favicon
  let link = document.getElementById("dynamic-favicon");

  if (!link) {
    link = document.createElement("link");

    link.id = "dynamic-favicon";

    link.rel = "icon";

    document.head.appendChild(link);
  }

  link.href = (favicon || DEFAULT_FAVICON) + "?v=" + Date.now();
};

//  Save branding
export const saveBranding = ({ title, favicon }) => {
  const brandingData = {
    title: title || DEFAULT_TITLE,

    favicon: favicon || DEFAULT_FAVICON,
  };

  localStorage.setItem("branding", JSON.stringify(brandingData));

  return brandingData;
};

//  Load branding
export const loadBranding = () => {
  try {
    const cached = localStorage.getItem("branding");

    if (cached) {
      const brandingData = JSON.parse(cached);

      applyBranding(brandingData);

      return brandingData;
    }

    applyBranding({});

    return null;
  } catch (error) {
    applyBranding({});

    return null;
  }
};

//  Clear branding
export const clearBranding = () => {
  localStorage.removeItem("branding");

  applyBranding({});
};
